import newyork from "./office.svg"
const NewYork = () => {
    return (
        <div className='w-full mx-auto hidden lg:block lg:px-12 lg:py-12 text-zinc-800 dark:text-zinc-200 text-sm'>
            <img src={newyork} alt="New York" className='rounded-sm shadow-md opacity-90 dark:opacity-100 transition-opacity duration-300'></img>
        </div>
    )
}

export default NewYork